import React from "react";
import { RelatedLinks } from "../components/site/RelatedLinks";
import { Link } from "react-router-dom";
import { Clock, ArrowRight, ExternalLink } from "lucide-react";
import { PageHero, SectionHead } from "../components/site/Common";
import { TOURS, IMG, TOURS_SITE, TOURS_PAGE } from "../mock";
import { SeoExtras } from "../components/site/SeoExtras";
import { useReveal } from "../lib/lang";

const Tours = () => {
  useReveal();
  return (
    <div data-testid="tours-page">
      <PageHero image={IMG.tours} eyebrow="Private experiences" title={TOURS_PAGE.title}
        sub={TOURS_PAGE.sub}>
        <a href={TOURS_SITE} target="_blank" rel="noopener" data-testid="tours-site-btn-hero"
          className="mt-6 sm:mt-8 inline-flex items-center gap-2 rounded-full bg-[#F7F3EA] text-[#183C35] px-6 sm:px-7 py-3 sm:py-3.5 text-[15px] sm:text-[16px] font-semibold hover:bg-white transition-colors duration-200">
          Visit our tours website <ExternalLink className="w-4 h-4" />
        </a>
      </PageHero>
      <section className="py-12 sm:py-24">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHead eyebrow="Curated by locals" title="Exclusive Corfu Island Tours" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-6 sm:mt-12">
            {TOURS.map((t) => (
              <Link key={t.slug} to={`/tours/${t.slug}`} className="reveal lift group bg-white rounded-2xl overflow-hidden border border-[#183C35]/10 flex flex-col" data-testid="tour-card">
                <div className="relative h-44 sm:h-56 overflow-hidden">
                  <img src={t.image.replace("w=2000", "w=1200")} srcSet={`${t.image.replace("w=2000", "w=700")} 700w, ${t.image.replace("w=2000", "w=1200")} 1200w`} sizes="(max-width: 640px) 100vw, 50vw" loading="lazy" alt={`${t.title} – Aloha Corfu tours, exclusive private island tour in Corfu`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute top-3 left-3 flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-[12.5px] font-medium text-[#183C35]"><Clock className="w-3.5 h-3.5" />{t.hours} hours</span>
                </div>
                <div className="p-4 sm:p-6 flex flex-col flex-1">
                  <h3 className="font-serif-d text-[19px] sm:text-[22px] font-semibold text-[#183C35]">{t.title}</h3>
                  <p className="mt-2 sm:mt-2.5 text-[14px] sm:text-[15px] leading-relaxed text-[#202522]/70 flex-1 line-clamp-3 sm:line-clamp-none">{t.desc}</p>
                  <div className="mt-5 pt-4 border-t border-[#183C35]/10 flex items-end justify-between">
                    <div>
                      <p className="font-serif-d text-[18px] text-[#183C35]">Price on request</p>
                      <p className="text-[13px] text-[#202522]/60">Ask us on WhatsApp</p>
                    </div>
                    <span className="inline-flex items-center gap-1.5 text-[15px] font-medium text-[#3E7F8E]">View tour <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <p className="mt-8 text-[14px] text-[#202522]/60">Private tours are tailored to you — open any tour and tap "Get price on WhatsApp" for a quick quote.</p>
          <div className="mt-8 sm:mt-12 rounded-2xl bg-[#183C35] text-[#F7F3EA] p-6 sm:p-10 flex flex-col sm:flex-row sm:items-center justify-between gap-5" data-testid="tours-site-banner">
            <div>
              <p className="font-serif-d text-[24px] sm:text-[30px] leading-tight">More tours on Aloha Corfu Tours</p>
              <p className="mt-2 text-[14.5px] sm:text-[16px] text-[#F7F3EA]/75">See all our island tours, photos and itineraries on our dedicated tours website.</p>
            </div>
            <a href={TOURS_SITE} target="_blank" rel="noopener" data-testid="tours-site-btn"
              className="shrink-0 inline-flex items-center justify-center gap-2 rounded-full bg-[#F7F3EA] text-[#183C35] px-7 py-3.5 text-[16px] font-semibold hover:bg-white transition-colors duration-200">
              Visit alohacorfutours.com <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>
      <SeoExtras path="/tours" page="tours" />
      <RelatedLinks current="/tours" />
    </div>
  );
};

export default Tours;
